import {useCallback, useEffect, useState} from 'react';

import {tierService} from '@/services/tierService';
import type {AfriexRatePromo} from '@/types';
import {getErrorMessage} from '@/utils/errorMessage';
import {logger} from '@/utils/logger';
import {showErrorMessage} from '@/utils/showErrorMessage';

type TierDetailsReturnProps = {
  isLoading: boolean;
  // `tierService.getTier` returns an `AfriexRatePromo`; this used to declare
  // `AfriexTier`, which does not describe the endpoint's payload.
  tier: AfriexRatePromo;
};

const useTierDetails = (tierId: string): TierDetailsReturnProps => {
  const [isLoading, setIsLoading] = useState(true);
  const [tier, setTier] = useState<AfriexRatePromo>({} as AfriexRatePromo);
  const fetchTierDetails = useCallback(async (id: string) => {
    try {
      setIsLoading(true);
      const tierItem = await tierService.getTier(id);
      setTier(tierItem);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      showErrorMessage(
        'Tier details could not be fetched:' +
          getErrorMessage(err, String(err)),
      );
    }
  }, []);
  useEffect(() => {
    // `fetchTierDetails` try/catches into showErrorMessage, so this only fires
    // if that reporting itself threw. Dev logger rather than a second toast:
    // the admin has already been told, and a toast is what just failed.
    fetchTierDetails(tierId).catch(logger.error);
  }, [fetchTierDetails, tierId]);

  return {isLoading, tier};
};
export default useTierDetails;
